import { AREA_SELECT_PROVINCE, AREA_SELECT_CITY } from '../constants/areaConstants'

export const setSelectedProvince = (value) => {
    return {
        type: AREA_SELECT_PROVINCE,
        province: value
    };
}

export const setSelectedCity = (value) => {
    return {
        type: AREA_SELECT_CITY,
        city: value
    };
}